import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { SplitText } from './SplitText';
import { EASE_OUT } from '../../utils/motion';
type PageHeroProps = {
  label: string;
  title: string;
  description: string;
  image?: string;
};
export function PageHero({
  label,
  title,
  description,
  image
}: PageHeroProps) {
  const ref = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start start', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], ['0%', '20%']);
  return <section className="bg-ink px-3 pb-3 pt-[76px] sm:px-5 sm:pb-5" data-id="element-398" data-mp="12ghmj71fb2ge">
      <div ref={ref} className="relative isolate flex min-h-[460px] items-end overflow-hidden rounded-[28px] bg-ink-800 lg:min-h-[540px]" data-id="element-399" data-mp="xeilw4x2ijn5">
        {image && <>
            <motion.img src={image} alt="" style={{
          y
        }} className="absolute inset-0 -z-20 h-[120%] w-full object-cover" data-id="element-400" data-mp="3i59if59alq6j" />
            <div className="absolute inset-0 -z-10 bg-ink/70" data-id="element-401" data-mp="2y3mo5f5kg58v" />
          </>}
        <div className="w-full px-6 pb-12 pt-24 sm:px-12 lg:px-16 lg:pb-16" data-id="element-402" data-mp="2j62pepz9j6b5">
          <motion.nav aria-label="Fil d’Ariane" initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.25,
          ease: EASE_OUT
        }} className="mb-6 flex items-center gap-1.5 text-sm text-white/60" data-id="element-403" data-mp="2j86rd2dlpv8s">
            <Link to="/" className="transition-colors duration-150 hover:text-white" data-id="element-404" data-mp="2f6218dmd3gqw">
              Accueil
            </Link>
            <ChevronRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-405" data-mp="25e5z8rh5n6he" />
            <span className="text-white" data-id="element-406" data-mp="25c30nj1xs512">{label}</span>
          </motion.nav>
          <h1 className="max-w-4xl text-[clamp(2.4rem,5.5vw,4.5rem)] font-medium leading-[1.04] tracking-[-0.03em] text-white" data-id="element-407" data-mp="1rfg4hiht5iw7">
            <SplitText text={title} delay={0.05} data-id="element-408" data-mp="1xiwej74go5v" />
          </h1>
          <motion.p initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: EASE_OUT,
          delay: 0.35
        }} className="mt-6 max-w-2xl text-lg leading-relaxed text-white/75" data-id="element-409" data-mp="1z3v8l0gyt9j">
            {description}
          </motion.p>
        </div>
      </div>
    </section>;
}